import { ButtonCompound, Flex, Icon, Menu, Text } from '@servicetitan/anvil2';
import IconAccount from '@servicetitan/anvil2/assets/icons/material/round/account_circle.svg';
import IconDown from '@servicetitan/anvil2/assets/icons/material/round/keyboard_arrow_down.svg';
import IconUp from '@servicetitan/anvil2/assets/icons/material/round/keyboard_arrow_up.svg';
import { FC } from 'react';

export const ProfileMenu: FC = () => {
    return (
        <Menu
            trigger={props => (
                <ButtonCompound {...props} data-cy="ish-page-header-profile-button">
                    <Flex direction="row" alignItems="center" gap="1">
                        <span
                            style={{
                                color: 'var(--a2-foreground-color-default)',
                                background: 'var(--a2-foreground-color-inverted)',
                                borderRadius: '50%',
                                border: '1px solid',
                                lineHeight: 0,
                            }}
                        >
                            <Icon svg={IconAccount} size="medium" inherit />
                        </span>
                        <span
                            style={{
                                marginTop: 'var(--a2-size-1)',
                                color: 'var(--a2-foreground-color-default)',
                            }}
                        >
                            <Icon
                                svg={props['data-state'] === 'open' ? IconUp : IconDown}
                                inherit
                            />
                        </span>
                    </Flex>
                </ButtonCompound>
            )}
        >
            <Text variant="eyebrow" size="small" className="p-2" data-cy="ish-page-header-version">
                support hub version 0.5
            </Text>
        </Menu>
    );
};
